module.exports = __webpack_public_path__ + "static/media/empty-fabrics.94edf939.svg";